export const CLASS_NAMES = {
  wrapper:
    "absolute right-0 flex flex-row mb-2 -mt-10 md:-mt-8 border border-solid border-neutral-500 text-neutral-500 rounded-md shadow-card overflow-hidden bg-neutral-000",
};
